import React from 'react';
import { Box, Checkbox, InputLabel, Typography } from '@p81-common/ui';
import { ErrorAttentionBox, NeutralInfoBox, RuleViolationList } from '../ui';
import { RuleViolation } from '../../../helpers/types';
import { createClasses } from './styles';

export interface SummaryRow {
  label: string;
  value: string;
}

interface ConfirmAndRunStepProps {
  scheduledConfirmed: boolean;
  onConfirmChange: (next: boolean) => void;
  summaryRows: SummaryRow[];
  actions: string[];
  actionsTitle: string;
  confirmCheckboxLabel: string;
  /**
   * Upfront validation failures from a rejected attempt. Shown here, above the
   * summary, because they are all fixable from this wizard's own inputs - the
   * operator corrects a field and runs again without re-entering anything.
   */
  upfrontErrors?: RuleViolation[];
  upfrontErrorsTitle?: string;
}

const ConfirmAndRunStep = ({
  scheduledConfirmed,
  onConfirmChange,
  summaryRows,
  actions,
  actionsTitle,
  confirmCheckboxLabel,
  upfrontErrors,
  upfrontErrorsTitle
}: ConfirmAndRunStepProps) => {
  const classes = createClasses();

  return (
    <Box className={classes.container}>
      {upfrontErrors && upfrontErrors.length > 0 && (
        <ErrorAttentionBox title={upfrontErrorsTitle ?? ''}>
          <RuleViolationList violations={upfrontErrors} />
        </ErrorAttentionBox>
      )}

      <Box className={classes.summaryBox}>
        {summaryRows.map(({ label, value }) => (
          <Box key={label} className={classes.summaryRow}>
            <Typography variant="body2" className={classes.summaryLabel}>
              {label}
            </Typography>
            <Typography variant="body2" className={classes.summaryValue}>
              {value}
            </Typography>
          </Box>
        ))}
      </Box>

      <NeutralInfoBox title={actionsTitle}>
        <Box
          component="ol"
          className={classes.actionsList}
          aria-label={actionsTitle}
        >
          {actions.map(action => (
            <Typography component="li" variant="body2" key={action}>
              {action}
            </Typography>
          ))}
        </Box>
      </NeutralInfoBox>

      <InputLabel className={classes.confirmationLabel}>
        <Checkbox
          checked={scheduledConfirmed}
          onChange={e => onConfirmChange(e.target.checked)}
        />
        <Typography variant="body2">{confirmCheckboxLabel}</Typography>
      </InputLabel>
    </Box>
  );
};

export default ConfirmAndRunStep;
